import axios from "axios";
import {
  FETCH_BATTERY_SOH,
  HANDLE_ERRORS,
  LOADING_MODE
} from "./types";
import authorizeRequest from "../helpers/authorize-request";
import BASE_URL from '../helpers/base-url';

export const getBatterySoh = () => async (dispatch, getState) => {
  const URL = `${BASE_URL}/api/external/metric/14`;

  dispatch({ type: LOADING_MODE, payload: true });

  try {
    // fetch data from api and popualate state
    const response = await axios.get(URL, authorizeRequest());

    await dispatch({
      type: FETCH_BATTERY_SOH,
      payload: response.data.results[0]
    });

    dispatch({ type: LOADING_MODE, payload: false });

    dispatch({
      type: HANDLE_ERRORS,
      payload: { message: "", open: false }
    });
  } catch (error) {
    console.error("Error fetching current battery info", error);
    dispatch({
      type: HANDLE_ERRORS,
      payload: { message: error.message, open: true }
    });
    dispatch({ type: LOADING_MODE, payload: false });
  }
};


// WEBPACK FOOTER //
// ./src/actions/getBatterySoh.js